import React from 'react'
import classnames from 'classnames'
import './Button.css'

const Button = ({ children, primary, ghost, iconLeft, iconRight, ...rest }) => {
  const classes = classnames({
    Button: true,
    primary,
    ghost,
    iconLeft,
    iconRight,
  })

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js